export default "__VITE_ASSET__DdU_TQFQ__"